import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
} from '@mui/material';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import firebase from 'firebase/compat/app';
import firebaseConfig from "../firebaseConfig";
import 'firebase/compat/firestore'; // for cloud firestore

// Initialize Firebase if not already initialized
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const auth = getAuth();
const db = firebase.firestore();

function SignupDialog(props) {
  const { open, onClose, onSignup } = props;

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  const handleSignup = () => {
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;

        // Clear form
        setEmail('');
        setPassword('');
        setConfirmPassword('');
        setError('');
        onClose();

        // Add user to Firestore users collection
        const userRef = db.collection('users').doc(user.uid);
        userRef.set({
          uid: user.uid,
          email: user.email,
          displayName: null,
          photoURL: null,
          friends: [],
          notes: [],
          ownedNotes: [],
          transferredNotes: [],
          favorites: [],
          events: [],
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          darkMode: false,
          notesAllocated: 0,
        }).catch((error) => {
          console.error("Error saving user:", error);
        });
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        setError(errorMessage);
        console.error('Error signing up:', error);
      });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Sign Up</DialogTitle>
      <DialogContent>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            '& .MuiTextField-root': {
              margin: 1,
            },
          }}
        >
          <TextField
            required
            id="email"
            label="Email"
            value={email}
            onChange={handleEmailChange}
            fullWidth
            margin="normal"
          />
          <TextField
            required
            id="password"
            label="Password"
            type="password"
            value={password}
            onChange={handlePasswordChange}
            fullWidth
            margin="normal"
          />
          <TextField
            required
            id="confirm-password"
            label="Confirm Password"
            type="password"
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            fullWidth
            margin="normal"
          />
          {error && <Box sx={{ color: 'error.main', mt: 1 }}>{error}</Box>}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSignup} color="primary">
          Sign Up
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SignupDialog;
